export const PREFERENCES_TABLE_HEADER = [
  "Features",
  "Description",
  "User Role Access",
];

export const ROLE_PREFERENCES = {
  transmission_table: {
    oru: [],
    eSig: [],
    signedBy: [],
    signedAt: [],
  },
  transmission_report: {
    nurse_flag: [],
    anticoag_status: [],
    tasks: [],
  },
  manual_upload: {
    devices: [],
    report_upload: [],
  },
};

export const ROLE_PREFERENCES_FEATURES = {
  transmission_table: "Transmission Table",
  transmission_report: "Transmission Report",
  manual_upload: "Manual Upload",
};

export const ROLE_PREFERENCES_FIELD = {
  // report_date: "Report Date",
  oru: "Oru",
  eSig: "Signature",
  signedBy: "Signed By",
  signedAt: "Signed At",
  patient_name: "Patient Name",
  device_alert: "Device Alert",
  manufacturer: "Manufacturer",
  device_category: "Device Category",
  nurse_flag: "Nurse Flag Toggle",
  tasks: "Tasks",
  anticoag_status: "Anticoagulant Toggle",
  devices: "Devices",
  report_upload: "Report Upload",
  inoffice_note_upload: "In-Office Note File Upload",
};

export const ROLE_PREFERENCES_FIELD_DESCRIPTION = {
  // report_date: "Report Date",
  oru: "Oru Column",
  eSig: "Signature Column",
  signedBy: "Signed By Column",
  signedAt: "Signed At Column",
  patient_name: "Name of the patient",
  device_alert: "Toggle for device alert",
  manufacturer: "Manufacturer of the device",
  device_category: "Device Category",
  nurse_flag: "Nurse flag Toggle",
  tasks: "Report tasks",
  anticoag_status: "Turn anticoagulant on, off, or unknown",
  devices: "Devices",
  report_upload: "Report Upload",
  inoffice_note_upload: "In-Office Note File Upload",
};

export const USER_ROLES = [
  "Admin",
  "User",
  "Assistant",
  "Physician",
  "Clinician",
  "ClinicAdmin",
];

export const MAP_PREFERENCE_USER_ROLES = {
  admin: "Admin",
  user: "User",
  assistant: "Assistant",
  physician: "Physician",
  clinic: "Clinician",
  clinicAdmin: "ClinicAdmin",
};

export const USER_PREFERENCE_ROLES_MAP = {
  Admin: "admin",
  User: "user",
  Assistant: "assistant",
  Physician: "physician",
  Clinician: "clinic",
  ClinicAdmin: "clinicAdmin",
};
